<template>
	<section class="view-ui-icon-places">
		<svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17.9349 5.83652C17.2279 4.44254 16.1818 3.24867 14.8928 2.36466C13.6037 1.48064 12.1132 0.934861 10.5581 0.777486C9.85463 0.706903 9.14586 0.706903 8.44239 0.777486C6.88734 0.934964 5.3968 1.48073 4.10774 2.36464C2.81867 3.24854 1.77242 4.44224 1.06512 5.83605C0.175225 7.61447 -0.168504 9.61646 0.077225 11.5899C0.322954 13.5633 1.14715 15.4198 2.44601 16.9257L8.77973 24.6262C8.8672 24.7326 8.97715 24.8183 9.1017 24.8772C9.22624 24.936 9.36227 24.9665 9.50001 24.9665C9.63775 24.9665 9.77378 24.936 9.89832 24.8772C10.0229 24.8183 10.1328 24.7326 10.2203 24.6262L16.554 16.9257C17.8529 15.4199 18.677 13.5634 18.9228 11.5901C19.1685 9.61677 18.8248 7.61486 17.9349 5.83652ZM9.50001 13.7774C8.76236 13.7774 8.04128 13.5587 7.42795 13.1489C6.81462 12.7391 6.33658 12.1566 6.0543 11.4751C5.77201 10.7936 5.69815 10.0437 5.84206 9.3202C5.98597 8.59673 6.34118 7.93217 6.86278 7.41058C7.38437 6.88898 8.04893 6.53377 8.7724 6.38986C9.49587 6.24595 10.2458 6.31981 10.9273 6.6021C11.6088 6.88438 12.1913 7.36242 12.6011 7.97575C13.0109 8.58908 13.2296 9.31016 13.2296 10.0478C13.2285 11.0366 12.8352 11.9846 12.136 12.6838C11.4368 13.383 10.4888 13.7763 9.50001 13.7774Z"
				fill="currentColor"
			/>
		</svg>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Icon
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiIconPlaces extends ViewBase {
		// Not implemented
	}
</script>
